export default __webpack_public_path__ + "static/media/close.980f8cb7.png";